//export const BASE_URL = 'https://localhost:5001/api/';
export const BASE_URL = 'https://inventorydashboard.prodashes.com/api/';